import useDrawer from './useDrawer';

const useDialog = useDrawer;

export default useDialog;
